<template>
  <b-container fluid>
    <b-row>
      <b-col id="reportConsoleLeftSide" lg="4" md="4" sm="12">
        <appBdmCommissionGenerate></appBdmCommissionGenerate>
      </b-col>

      <b-col id="reportConsoleRightSide" lg="8" md="8" sm="12" v-if="getBDMCommissions.length > 0">
        <div>
          <appBmCommissionView
            :prosData="getBDMCommissions"
            :commissionYear="getBDMCommissionParam.commissionYear"
            :commissionMonth="getBDMCommissionParam.commissionMonth"
            :referredByBDM="getBDMCommissionParam.referredByBDM"
            :stakeHolderType="getBDMCommissionParam.stakeHolderTypeView"
          >
          </appBmCommissionView>
        </div>
        <!-- <div v-if="stakeHolderTypeView == 'rp'">
          <appBmCommissionView
            :prosData="getBDMCommissions"
            :commissionYear="getBDMCommissionParam.commissionYear"
            :commissionMonth="getBDMCommissionParam.commissionMonth"
            :referredByBDM="getBDMCommissionParam.referredByBDM"
            :stakeHolderType="getBDMCommissionParam.stakeHolderTypeView"
          >
          </appBmCommissionView>
        </div> -->
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import datePicker from 'vue2-datepicker'
import appBdmCommissionGenerate from '../../../components/reports/bdm/bdmCommissionGenerate.vue'
import appBmCommissionView from '../../../components/reports/bdm/bdmCommissionView.vue'


export default {
  name: 'Report',
  components: {
    datePicker,
    appBdmCommissionGenerate,
    appBmCommissionView,
  },
  mounted() {},
  data() {
    return {
      errors: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getBDMCommissionParam', 'getInvoiceData', 'getBDMCommissions']),
    invoiceYearView() {
      return this.getBDMCommissionParam.commissionYear
    },
    invoiceMonthView() {
      return this.getBDMCommissionParam.commissionMonth
    },
    stakeHolderTypeView() {
      return this.getBDMCommissionParam.stakeHolderTypeView
    }
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
@page {
  /* size: A4 portrait;  */
  width: 210mm;
  height: 280mm;
  margin: 20px 20px 20px 20px;
  padding: 0;
}
@media print {
  body * {
    visibility: hidden;
  }
  #quickQuotePage {
    display: none !important;
  }
  #quickQuotePage2 {
    display: none !important;
  }
  #printMe,
  #printMe * {
    visibility: visible !important;
  }
  #printMe {
    position: absolute !important;
    left: 0px !important;
    top: 0px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
